// XAccount + XPost i18n fragment
const fragment = {
  vi: {
    // ===== XAccount · list (xAccount) =====
    'xAcc.xAccount.title': 'Tài khoản X (Twitter)',
    'xAcc.xAccount.add': 'Thêm',
    'xAcc.xAccount.searchLabel': 'Tìm kiếm tài khoản',
    'xAcc.xAccount.searchPlaceholder': 'Tìm theo username hoặc tên',
    'xAcc.xAccount.search': 'Tìm kiếm',
    'xAcc.xAccount.reset': 'Đặt lại',

    // ===== XAccount · table =====
    'xAcc.table.col.account': 'Tài khoản',
    'xAcc.table.col.usage24h': 'Đăng 24h',
    'xAcc.table.col.status': 'Trạng thái',
    'xAcc.table.col.createdAt': 'Ngày tạo',
    'xAcc.table.col.actions': 'Thao tác',
    'xAcc.table.usageTip.block':
      'Đã chạm giới hạn {used}/{limit} tweet/24h ({tier}). Reset {reset}.',
    'xAcc.table.usageTip.ok': 'Đã đăng {used}/{limit} tweet trong 24h gần nhất ({tier} tier).',
    'xAcc.table.usageTip.windowReset': 'Window reset {reset}.',
    'xAcc.table.tooltip.edit': 'Cập nhật tài khoản',
    'xAcc.table.tooltip.delete': 'Xoá tài khoản',
    'xAcc.table.delete.title': 'Xoá tài khoản X?',
    'xAcc.table.delete.desc': 'Hành động này không thể hoàn tác.',
    'xAcc.table.delete.confirm': 'Xoá',
    'xAcc.table.empty.title': 'Chưa có tài khoản X',
    'xAcc.table.empty.desc': 'Liên kết tài khoản X đầu tiên để bắt đầu',
    'xAcc.table.toast.statusChanged': 'Đã thay đổi trạng thái tài khoản',
    'xAcc.table.toast.statusError': 'Thay đổi trạng thái tài khoản thất bại',
    'xAcc.table.toast.deleteSuccess': 'Xoá tài khoản thành công',
    'xAcc.table.toast.deleteError': 'Xoá tài khoản thất bại',

    // ===== XAccount · form (xAccountForm) =====
    'xAcc.xAccountForm.title.create': 'Tạo tài khoản X',
    'xAcc.xAccountForm.title.update': 'Cập nhật tài khoản X',
    'xAcc.xAccountForm.linked': 'Đã liên kết tài khoản X',
    'xAcc.xAccountForm.login': 'Đăng nhập với X',
    'xAcc.xAccountForm.loginAgain': 'Đăng nhập lại X',
    'xAcc.xAccountForm.create': 'Tạo',
    'xAcc.xAccountForm.update': 'Cập nhật',
    'xAcc.xAccountForm.nameLabel': 'Tên gợi nhớ',
    'xAcc.xAccountForm.active': 'Kích hoạt',
    'xAcc.xAccountForm.cancel': 'Hủy',
    'xAcc.xAccountForm.toast.loginDenied': 'X từ chối đăng nhập: {reason}',
    'xAcc.xAccountForm.toast.invalidState': 'State OAuth không hợp lệ, vui lòng đăng nhập lại.',
    'xAcc.xAccountForm.toast.missingVerifier': 'Thiếu code_verifier, vui lòng đăng nhập lại.',
    'xAcc.xAccountForm.toast.fetchProfileError': 'Lấy thông tin tài khoản X thất bại',
    'xAcc.xAccountForm.toast.missingClientId': 'Thiếu cấu hình REACT_APP_X_CLIENT_ID.',
    'xAcc.xAccountForm.toast.pkceError': 'Không khởi tạo được PKCE cho X OAuth.',
    'xAcc.xAccountForm.toast.updateSuccess': 'Cập nhật tài khoản thành công.',
    'xAcc.xAccountForm.toast.updateError': 'Cập nhật tài khoản thất bại.',
    'xAcc.xAccountForm.toast.needLogin': 'Bạn cần đăng nhập X trước khi tạo tài khoản.',
    'xAcc.xAccountForm.toast.createSuccess': 'Tạo tài khoản thành công.',
    'xAcc.xAccountForm.toast.createError': 'Tạo tài khoản thất bại.',

    // ===== XPost · list (xPost) =====
    'xPost.xPost.title': 'Bài viết X (Twitter)',
    'xPost.xPost.create': 'Tạo bài viết',
    'xPost.xPost.searchLabel': 'Tìm kiếm',
    'xPost.xPost.searchPlaceholder': 'Tìm theo nội dung tweet',
    'xPost.xPost.accountLabel': 'Tài khoản',
    'xPost.xPost.allAccounts': 'Tất cả tài khoản',
    'xPost.xPost.statusLabel': 'Trạng thái',
    'xPost.xPost.filter': 'Lọc',
    'xPost.xPost.reset': 'Đặt lại',
    'xPost.xPost.status.all': 'Tất cả trạng thái',
    'xPost.xPost.status.draft': 'Nháp',
    'xPost.xPost.status.scheduled': 'Đã lên lịch',
    'xPost.xPost.status.published': 'Đã đăng',
    'xPost.xPost.status.failed': 'Lỗi',
    'xPost.xPost.tab.all': 'Tất cả',
    'xPost.xPost.tab.draft': 'Nháp',
    'xPost.xPost.tab.scheduled': 'Đã lên lịch',
    'xPost.xPost.tab.published': 'Đã đăng',
    'xPost.xPost.tab.failed': 'Lỗi',

    // ===== XPost · table =====
    'xPost.table.status.published': 'Đã đăng',
    'xPost.table.status.failed': 'Lỗi',
    'xPost.table.status.scheduled': 'Đã lên lịch',
    'xPost.table.status.processing': 'Đang đăng',
    'xPost.table.status.draft': 'Nháp',
    'xPost.table.time.waitingCron': 'Đang chờ cron xử lý',
    'xPost.table.time.processing': 'Đang đăng…',
    'xPost.table.reschedule.tooltip': 'Đổi giờ đăng',
    'xPost.table.reschedule.title': 'Đổi giờ đăng',
    'xPost.table.reschedule.placeholder': 'Chọn ngày giờ mới',
    'xPost.table.reschedule.minLead': 'Cách hiện tại tối thiểu {minutes} phút.',
    'xPost.table.reschedule.cancel': 'Huỷ',
    'xPost.table.reschedule.save': 'Lưu lịch',
    'xPost.table.col.account': 'Tài khoản',
    'xPost.table.col.content': 'Nội dung',
    'xPost.table.col.status': 'Trạng thái',
    'xPost.table.col.time': 'Thời gian',
    'xPost.table.col.tweetLink': 'Link tweet',
    'xPost.table.col.createdAt': 'Tạo lúc',
    'xPost.table.col.actions': 'Thao tác',
    'xPost.table.copyLink': 'Sao chép link',
    'xPost.table.action.viewOnX': 'Xem trên X',
    'xPost.table.action.cancelSchedule': 'Huỷ lịch đăng',
    'xPost.table.action.publishNow': 'Đăng ngay',
    'xPost.table.action.edit': 'Sửa bài viết',
    'xPost.table.action.delete': 'Xoá bài viết',
    'xPost.table.empty.title': 'Chưa có bài viết',
    'xPost.table.empty.desc': 'Tạo tweet đầu tiên để đăng lên X',
    'xPost.table.delete.title': 'Xoá bài viết?',
    'xPost.table.delete.desc': 'Bài viết sẽ bị xoá khỏi hệ thống. Tweet đã đăng trên X vẫn còn.',
    'xPost.table.delete.confirm': 'Xoá',
    'xPost.table.publish.title': 'Đăng ngay bài đã lên lịch?',
    'xPost.table.publish.desc': 'Lịch đăng tự động sẽ bị huỷ và bài sẽ được đăng ngay lập tức.',
    'xPost.table.publish.confirm': 'Đăng ngay',
    'xPost.table.cancelSchedule.title': 'Huỷ lịch đăng?',
    'xPost.table.cancelSchedule.desc':
      'Bài sẽ chuyển về trạng thái Nháp và không tự động đăng nữa.',
    'xPost.table.cancelSchedule.confirm': 'Huỷ lịch',
    'xPost.table.toast.pickTime': 'Vui lòng chọn thời gian.',
    'xPost.table.toast.leadTime': 'Thời gian đăng phải cách hiện tại ít nhất {minutes} phút.',
    'xPost.table.toast.deleteSuccess': 'Đã xoá bài viết.',
    'xPost.table.toast.publishSuccess': 'Đăng tweet thành công.',
    'xPost.table.toast.publishError': 'Đăng tweet thất bại.',
    'xPost.table.toast.rescheduleSuccess': 'Đã cập nhật lịch đăng.',
    'xPost.table.toast.rescheduleError': 'Cập nhật lịch thất bại.',
    'xPost.table.toast.cancelSuccess': 'Đã huỷ lịch đăng.',
    'xPost.table.toast.cancelError': 'Huỷ lịch thất bại.',

    // ===== XPost · form (xPostForm) =====
    'xPost.xPostForm.status.published': 'Đã đăng',
    'xPost.xPostForm.status.failed': 'Lỗi',
    'xPost.xPostForm.status.scheduled': 'Đã lên lịch',
    'xPost.xPostForm.status.processing': 'Đang đăng',
    'xPost.xPostForm.status.draft': 'Nháp',
    'xPost.xPostForm.counter.urlNote': 'URL × {count} = +{chars} ký tự',
    'xPost.xPostForm.counter.weighted': 'Counter theo X (weighted).',
    'xPost.xPostForm.counter.trim': 'Cắt cho vừa {limit}',
    'xPost.xPostForm.preview.placeholder': 'Nội dung tweet sẽ hiển thị ở đây...',
    'xPost.xPostForm.title.edit': 'Sửa bài viết',
    'xPost.xPostForm.title.create': 'Tạo bài viết lên X',
    'xPost.xPostForm.subtitle':
      'Chọn tài khoản X và soạn nội dung. Lưu nháp, lên lịch hoặc đăng ngay.',
    'xPost.xPostForm.section1.title': 'Đăng từ tài khoản nào?',
    'xPost.xPostForm.section1.hint': 'Chọn tài khoản X đã liên kết',
    'xPost.xPostForm.accountLabel': 'Tài khoản X',
    'xPost.xPostForm.accountPlaceholder': 'Chọn tài khoản X',
    'xPost.xPostForm.noActiveAccount': 'Chưa có tài khoản X nào kích hoạt',
    'xPost.xPostForm.section2.title': 'Soạn tweet',
    'xPost.xPostForm.section2.hint': 'Tối đa {limit} ký tự (URL = 23 ký tự, emoji = 2)',
    'xPost.xPostForm.textareaPlaceholder': 'Bạn đang nghĩ gì?',
    'xPost.xPostForm.section3.title': 'Chế độ đăng',
    'xPost.xPostForm.section3.hint': 'Lưu nháp, lên lịch tự động hoặc đăng ngay lập tức',
    'xPost.xPostForm.mode.draft.label': 'Lưu nháp',
    'xPost.xPostForm.mode.draft.hint': 'Lưu tweet để chỉnh sửa và đăng sau.',
    'xPost.xPostForm.mode.schedule.label': 'Lên lịch',
    'xPost.xPostForm.mode.schedule.hint': 'Tự động đăng vào ngày giờ chỉ định.',
    'xPost.xPostForm.mode.publish.label': 'Đăng ngay',
    'xPost.xPostForm.mode.publish.hint': 'Gửi tweet lên X ngay lập tức.',
    'xPost.xPostForm.schedule.title': 'Thời gian đăng',
    'xPost.xPostForm.schedule.placeholder': 'Chọn ngày và giờ đăng',
    'xPost.xPostForm.schedule.timezonePrefix': 'Múi giờ:',
    'xPost.xPostForm.schedule.minLead': 'Tối thiểu cách hiện tại {minutes} phút.',
    'xPost.xPostForm.schedule.willPostPrefix': 'Sẽ đăng',
    'xPost.xPostForm.preview.heading': 'Xem trước',
    'xPost.xPostForm.preview.displayName': 'Tên hiển thị',
    'xPost.xPostForm.preview.now': 'Bây giờ',
    'xPost.xPostForm.preview.reply': 'Trả lời',
    'xPost.xPostForm.preview.retweet': 'Retweet',
    'xPost.xPostForm.preview.like': 'Thích',
    'xPost.xPostForm.preview.share': 'Chia sẻ',
    'xPost.xPostForm.footerHint.schedule':
      'Tweet sẽ được hệ thống tự động đăng đúng thời điểm bạn chọn.',
    'xPost.xPostForm.footerHint.publish': 'Tweet sẽ được gửi lên X ngay khi bạn nhấn nút.',
    'xPost.xPostForm.footerHint.draft': 'Nháp có thể chỉnh sửa, lên lịch hoặc đăng bất cứ lúc nào.',
    'xPost.xPostForm.cancel': 'Huỷ',
    'xPost.xPostForm.submit.updateSchedule': 'Cập nhật lịch',
    'xPost.xPostForm.submit.saveChanges': 'Lưu thay đổi',
    'xPost.xPostForm.submit.schedule': 'Lên lịch đăng',
    'xPost.xPostForm.submit.publishNow': 'Đăng ngay',
    'xPost.xPostForm.submit.saveDraft': 'Lưu nháp',
    'xPost.xPostForm.validate.pickAccount': 'Vui lòng chọn tài khoản X.',
    'xPost.xPostForm.validate.emptyContent': 'Tweet cần có nội dung.',
    'xPost.xPostForm.validate.overLimit':
      'Nội dung vượt quá {limit} ký tự (tính cả URL = 23 ký tự).',
    'xPost.xPostForm.validate.pickTime': 'Vui lòng chọn thời gian đăng.',
    'xPost.xPostForm.validate.leadTime':
      'Thời gian đăng phải cách hiện tại ít nhất {minutes} phút.',
    'xPost.xPostForm.toast.scheduleUpdated': 'Đã cập nhật lịch đăng.',
    'xPost.xPostForm.toast.changesSaved': 'Đã lưu thay đổi.',
    'xPost.xPostForm.toast.saveError': 'Lưu thất bại.',
    'xPost.xPostForm.toast.publishSuccess': 'Đăng tweet thành công!',
    'xPost.xPostForm.toast.sent': 'Đã gửi.',
    'xPost.xPostForm.toast.scheduledAt': 'Đã lên lịch đăng lúc {time}.',
    'xPost.xPostForm.toast.draftSaved': 'Đã lưu nháp.',
    'xPost.xPostForm.toast.createError': 'Tạo bài viết thất bại.',
  },
  en: {
    // ===== XAccount · list (xAccount) =====
    'xAcc.xAccount.title': 'X (Twitter) accounts',
    'xAcc.xAccount.add': 'Add',
    'xAcc.xAccount.searchLabel': 'Search accounts',
    'xAcc.xAccount.searchPlaceholder': 'Search by username or name',
    'xAcc.xAccount.search': 'Search',
    'xAcc.xAccount.reset': 'Reset',

    // ===== XAccount · table =====
    'xAcc.table.col.account': 'Account',
    'xAcc.table.col.usage24h': 'Posts (24h)',
    'xAcc.table.col.status': 'Status',
    'xAcc.table.col.createdAt': 'Created at',
    'xAcc.table.col.actions': 'Actions',
    'xAcc.table.usageTip.block':
      'Reached the limit of {used}/{limit} tweets/24h ({tier}). Resets {reset}.',
    'xAcc.table.usageTip.ok': 'Posted {used}/{limit} tweets in the last 24h ({tier} tier).',
    'xAcc.table.usageTip.windowReset': 'Window resets {reset}.',
    'xAcc.table.tooltip.edit': 'Update account',
    'xAcc.table.tooltip.delete': 'Delete account',
    'xAcc.table.delete.title': 'Delete X account?',
    'xAcc.table.delete.desc': 'This action cannot be undone.',
    'xAcc.table.delete.confirm': 'Delete',
    'xAcc.table.empty.title': 'No X accounts yet',
    'xAcc.table.empty.desc': 'Connect your first X account to get started',
    'xAcc.table.toast.statusChanged': 'Account status changed',
    'xAcc.table.toast.statusError': 'Failed to change account status',
    'xAcc.table.toast.deleteSuccess': 'Account deleted',
    'xAcc.table.toast.deleteError': 'Failed to delete account',

    // ===== XAccount · form (xAccountForm) =====
    'xAcc.xAccountForm.title.create': 'Connect X account',
    'xAcc.xAccountForm.title.update': 'Update X account',
    'xAcc.xAccountForm.linked': 'X account linked',
    'xAcc.xAccountForm.login': 'Sign in with X',
    'xAcc.xAccountForm.loginAgain': 'Sign in to X again',
    'xAcc.xAccountForm.create': 'Create',
    'xAcc.xAccountForm.update': 'Update',
    'xAcc.xAccountForm.nameLabel': 'Display name',
    'xAcc.xAccountForm.active': 'Active',
    'xAcc.xAccountForm.cancel': 'Cancel',
    'xAcc.xAccountForm.toast.loginDenied': 'X denied sign-in: {reason}',
    'xAcc.xAccountForm.toast.invalidState': 'Invalid OAuth state, please sign in again.',
    'xAcc.xAccountForm.toast.missingVerifier': 'Missing code_verifier, please sign in again.',
    'xAcc.xAccountForm.toast.fetchProfileError': 'Failed to fetch X account info',
    'xAcc.xAccountForm.toast.missingClientId': 'Missing REACT_APP_X_CLIENT_ID configuration.',
    'xAcc.xAccountForm.toast.pkceError': 'Could not initialize PKCE for X OAuth.',
    'xAcc.xAccountForm.toast.updateSuccess': 'Account updated successfully.',
    'xAcc.xAccountForm.toast.updateError': 'Failed to update account.',
    'xAcc.xAccountForm.toast.needLogin': 'You need to sign in to X before creating an account.',
    'xAcc.xAccountForm.toast.createSuccess': 'Account created successfully.',
    'xAcc.xAccountForm.toast.createError': 'Failed to create account.',

    // ===== XPost · list (xPost) =====
    'xPost.xPost.title': 'X (Twitter) posts',
    'xPost.xPost.create': 'New post',
    'xPost.xPost.searchLabel': 'Search',
    'xPost.xPost.searchPlaceholder': 'Search by tweet content',
    'xPost.xPost.accountLabel': 'Account',
    'xPost.xPost.allAccounts': 'All accounts',
    'xPost.xPost.statusLabel': 'Status',
    'xPost.xPost.filter': 'Filter',
    'xPost.xPost.reset': 'Reset',
    'xPost.xPost.status.all': 'All statuses',
    'xPost.xPost.status.draft': 'Draft',
    'xPost.xPost.status.scheduled': 'Scheduled',
    'xPost.xPost.status.published': 'Published',
    'xPost.xPost.status.failed': 'Failed',
    'xPost.xPost.tab.all': 'All',
    'xPost.xPost.tab.draft': 'Draft',
    'xPost.xPost.tab.scheduled': 'Scheduled',
    'xPost.xPost.tab.published': 'Published',
    'xPost.xPost.tab.failed': 'Failed',

    // ===== XPost · table =====
    'xPost.table.status.published': 'Published',
    'xPost.table.status.failed': 'Failed',
    'xPost.table.status.scheduled': 'Scheduled',
    'xPost.table.status.processing': 'Publishing',
    'xPost.table.status.draft': 'Draft',
    'xPost.table.time.waitingCron': 'Waiting for cron to process',
    'xPost.table.time.processing': 'Publishing…',
    'xPost.table.reschedule.tooltip': 'Change post time',
    'xPost.table.reschedule.title': 'Change post time',
    'xPost.table.reschedule.placeholder': 'Pick a new date & time',
    'xPost.table.reschedule.minLead': 'At least {minutes} minutes from now.',
    'xPost.table.reschedule.cancel': 'Cancel',
    'xPost.table.reschedule.save': 'Save schedule',
    'xPost.table.col.account': 'Account',
    'xPost.table.col.content': 'Content',
    'xPost.table.col.status': 'Status',
    'xPost.table.col.time': 'Time',
    'xPost.table.col.tweetLink': 'Tweet link',
    'xPost.table.col.createdAt': 'Created at',
    'xPost.table.col.actions': 'Actions',
    'xPost.table.copyLink': 'Copy link',
    'xPost.table.action.viewOnX': 'View on X',
    'xPost.table.action.cancelSchedule': 'Cancel schedule',
    'xPost.table.action.publishNow': 'Publish now',
    'xPost.table.action.edit': 'Edit post',
    'xPost.table.action.delete': 'Delete post',
    'xPost.table.empty.title': 'No posts yet',
    'xPost.table.empty.desc': 'Create your first tweet to post on X',
    'xPost.table.delete.title': 'Delete post?',
    'xPost.table.delete.desc':
      'The post will be removed from the system. The tweet already on X remains.',
    'xPost.table.delete.confirm': 'Delete',
    'xPost.table.publish.title': 'Publish the scheduled post now?',
    'xPost.table.publish.desc':
      'The automatic schedule will be canceled and the post will be published immediately.',
    'xPost.table.publish.confirm': 'Publish now',
    'xPost.table.cancelSchedule.title': 'Cancel schedule?',
    'xPost.table.cancelSchedule.desc':
      'The post will revert to Draft and will no longer post automatically.',
    'xPost.table.cancelSchedule.confirm': 'Cancel schedule',
    'xPost.table.toast.pickTime': 'Please pick a time.',
    'xPost.table.toast.leadTime': 'The post time must be at least {minutes} minutes from now.',
    'xPost.table.toast.deleteSuccess': 'Post deleted.',
    'xPost.table.toast.publishSuccess': 'Tweet published successfully.',
    'xPost.table.toast.publishError': 'Failed to publish tweet.',
    'xPost.table.toast.rescheduleSuccess': 'Schedule updated.',
    'xPost.table.toast.rescheduleError': 'Failed to update schedule.',
    'xPost.table.toast.cancelSuccess': 'Schedule canceled.',
    'xPost.table.toast.cancelError': 'Failed to cancel schedule.',

    // ===== XPost · form (xPostForm) =====
    'xPost.xPostForm.status.published': 'Published',
    'xPost.xPostForm.status.failed': 'Failed',
    'xPost.xPostForm.status.scheduled': 'Scheduled',
    'xPost.xPostForm.status.processing': 'Publishing',
    'xPost.xPostForm.status.draft': 'Draft',
    'xPost.xPostForm.counter.urlNote': 'URL × {count} = +{chars} chars',
    'xPost.xPostForm.counter.weighted': 'Counter follows X (weighted).',
    'xPost.xPostForm.counter.trim': 'Trim to fit {limit}',
    'xPost.xPostForm.preview.placeholder': 'Tweet content will appear here...',
    'xPost.xPostForm.title.edit': 'Edit post',
    'xPost.xPostForm.title.create': 'Create a post on X',
    'xPost.xPostForm.subtitle':
      'Pick an X account and write your content. Save a draft, schedule, or publish now.',
    'xPost.xPostForm.section1.title': 'Which account to post from?',
    'xPost.xPostForm.section1.hint': 'Choose a linked X account',
    'xPost.xPostForm.accountLabel': 'X account',
    'xPost.xPostForm.accountPlaceholder': 'Select an X account',
    'xPost.xPostForm.noActiveAccount': 'No active X account yet',
    'xPost.xPostForm.section2.title': 'Compose tweet',
    'xPost.xPostForm.section2.hint': 'Up to {limit} characters (URL = 23 chars, emoji = 2)',
    'xPost.xPostForm.textareaPlaceholder': "What's happening?",
    'xPost.xPostForm.section3.title': 'Posting mode',
    'xPost.xPostForm.section3.hint': 'Save a draft, auto-schedule, or publish immediately',
    'xPost.xPostForm.mode.draft.label': 'Save draft',
    'xPost.xPostForm.mode.draft.hint': 'Save the tweet to edit and post later.',
    'xPost.xPostForm.mode.schedule.label': 'Schedule',
    'xPost.xPostForm.mode.schedule.hint': 'Auto-post at the chosen date & time.',
    'xPost.xPostForm.mode.publish.label': 'Publish now',
    'xPost.xPostForm.mode.publish.hint': 'Send the tweet to X right away.',
    'xPost.xPostForm.schedule.title': 'Post time',
    'xPost.xPostForm.schedule.placeholder': 'Pick a date and time to post',
    'xPost.xPostForm.schedule.timezonePrefix': 'Timezone:',
    'xPost.xPostForm.schedule.minLead': 'At least {minutes} minutes from now.',
    'xPost.xPostForm.schedule.willPostPrefix': 'Will post',
    'xPost.xPostForm.preview.heading': 'Preview',
    'xPost.xPostForm.preview.displayName': 'Display name',
    'xPost.xPostForm.preview.now': 'Now',
    'xPost.xPostForm.preview.reply': 'Reply',
    'xPost.xPostForm.preview.retweet': 'Retweet',
    'xPost.xPostForm.preview.like': 'Like',
    'xPost.xPostForm.preview.share': 'Share',
    'xPost.xPostForm.footerHint.schedule':
      'The system will automatically post the tweet at the time you chose.',
    'xPost.xPostForm.footerHint.publish':
      'The tweet will be sent to X the moment you click the button.',
    'xPost.xPostForm.footerHint.draft': 'Drafts can be edited, scheduled, or posted anytime.',
    'xPost.xPostForm.cancel': 'Cancel',
    'xPost.xPostForm.submit.updateSchedule': 'Update schedule',
    'xPost.xPostForm.submit.saveChanges': 'Save changes',
    'xPost.xPostForm.submit.schedule': 'Schedule post',
    'xPost.xPostForm.submit.publishNow': 'Publish now',
    'xPost.xPostForm.submit.saveDraft': 'Save draft',
    'xPost.xPostForm.validate.pickAccount': 'Please choose an X account.',
    'xPost.xPostForm.validate.emptyContent': 'The tweet needs content.',
    'xPost.xPostForm.validate.overLimit':
      'Content exceeds {limit} characters (URLs count as 23 chars).',
    'xPost.xPostForm.validate.pickTime': 'Please choose a post time.',
    'xPost.xPostForm.validate.leadTime':
      'The post time must be at least {minutes} minutes from now.',
    'xPost.xPostForm.toast.scheduleUpdated': 'Schedule updated.',
    'xPost.xPostForm.toast.changesSaved': 'Changes saved.',
    'xPost.xPostForm.toast.saveError': 'Failed to save.',
    'xPost.xPostForm.toast.publishSuccess': 'Tweet published successfully!',
    'xPost.xPostForm.toast.sent': 'Sent.',
    'xPost.xPostForm.toast.scheduledAt': 'Scheduled to post at {time}.',
    'xPost.xPostForm.toast.draftSaved': 'Draft saved.',
    'xPost.xPostForm.toast.createError': 'Failed to create the post.',
  },
};

export default fragment;
